import { z } from 'zod';
import { isPPVSubPlanNumber } from '../schema/ProgrammingPlan/ProgrammingSubPlan';

const laboratoryShortNames = [
  'ANS 06',
  'ANS 22',
  'ANS 35a',
  'ANS 54',
  'ANS 62',
  'ANS 69',
  'ANS 94a',
  'ANS 94a - LNR ETM',
  'ANS 94a - LNR PEST',
  'SCL 33',
  'SCL 34',
  'SCL 35',
  'SCL 67',
  'SCL 75',
  'SCL 974',
  'LDA 01a',
  'LDA 01b',
  'LDA 02',
  'LDA 03',
  'LDA 04',
  'LDA 05',
  'LDA 06',
  'LDA 08',
  'LDA 09',
  'LDA 10',
  'LDA 11',
  'LDA 12',
  'LDA 13',
  'LDA 14',
  'LDA 15',
  'LDA 16',
  'LDA 17',
  'LDA 18',
  'LDA 19',
  'LDA 20b',
  'LDA 21',
  'LDA 22',
  'LDA 23',
  'LDA 24',
  'LDA 25',
  'LDA 26',
  'LDA 27',
  'LDA 29a',
  'LDA 29b',
  'LDA 30',
  'LDA 31',
  'LDA 32',
  'LDA 33a',
  'LDA 34',
  'LDA 35a',
  'LDA 35b',
  'LDA 36',
  'LDA 37',
  'LDA 38',
  'LDA 39',
  'LDA 40',
  'LDA 41',
  'LDA 42',
  'LDA 43',
  'LDA 44',
  'LDA 46',
  'LDA 48',
  'LDA 49',
  'LDA 50',
  'LDA 52',
  'LDA 53',
  'LDA 54',
  'LDA 55',
  'LDA 56a',
  'LDA 56b',
  'LDA 58',
  'LDA 59',
  'LDA 61',
  'LDA 62',
  'LDA 63',
  'LDA 64',
  'LDA 65',
  'LDA 66',
  'LDA 67',
  'LDA 68',
  'LDA 70',
  'LDA 71',
  'LDA 72',
  'LDA 73',
  'LDA 74',
  'LDA 76',
  'LDA 79',
  'LDA 80',
  'LDA 81',
  'LDA 82',
  'LDA 83',
  'LDA 85',
  'LDA 87',
  'LDA 88',
  'LDA 972',
  'LDA 974',
  'CAP 29',
  'CER 30',
  'CVP 35',
  'LAB 44',
  'GIR 49',
  'CEV 62',
  'CAR 69',
  'VET 69',
  'SAV73',
  'IPL 971',
  'RSN 78',
  'IFR 14',
  'IFR 17',
  'IFR 34',
  'IFR 44',
  'IFR 56',
  'UMR 94',
  'ACM 45',
  'SCL 13',
  'SCL 59',
  'SCL 69',
  'SCL 91',
  'SCL 971',
  'CITEB 974'
] as const satisfies string[];
export const laboratoryShortNameValidator = z.enum(laboratoryShortNames);
export type LaboratoryShortName = z.infer<typeof laboratoryShortNameValidator>;

export const LaboratoryWithAutomation = [
  'GIR 49',
  'LDA 72',
  'CAP 29',
  'CER 30',
  'ANS 94a - LNR PEST'
] as const satisfies LaboratoryShortName[];

export const isAnalysisCorrectionReportable = (
  subPlanNumber: string | undefined,
  laboratoryShortName: LaboratoryShortName | undefined
): boolean =>
  !isPPVSubPlanNumber(subPlanNumber) ||
  (laboratoryShortName !== undefined &&
    (LaboratoryWithAutomation as readonly string[]).includes(
      laboratoryShortName
    ));
